/**
 * The Regatta Pass's displayed price (copy only: what is charged comes from the Stripe price id,
 * STRIPE_PRICE_REGATTA). Its own module so the landing page can show it without loading the app.
 */
export const PRICE_REGATTA = '$50';
